const doc = [({"da":({"js":({"reimbursements":({"index":({"reimbursements":"Tidsrefusioner"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;